//Material
import { Grid } from "@mui/material";
//Interfaces and Types
import { TUserProfileErrorProps } from "../../types/UserProfile";

export default function UserProfileError({ error }: Readonly<TUserProfileErrorProps>) {
	return (
		<>
			{error && (
				<Grid direction="row" className="error-message-span !text-center">
					<svg
						className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
						focusable="false"
						viewBox="0 0 24 24"
						data-testid="ErrorOutlineOutlinedIcon"
					>
						<path
							d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8
								  s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
						></path>
					</svg>
					<span> {error} </span>
				</Grid>
			)}
		</>
	);
}
